<script>
import msBaseComponentDefaultVue from './msBaseComponentDefault.vue';

import {
	validateTaxCodeOrIdentification,
	validateTaxCode,
	validateIdentificationNumber,
	validateUsernameForTaxaxion,
} from '@/common/taxCode/taxCodeUtil';
export default {
	extends: msBaseComponentDefaultVue,
	name: 'msBaseComponent',
	props: {
		readonly: {
			default: false,
			type: Boolean,
		},
		//rule dùng để validate control
		//Created by LTDAT(22.06.2020)
		rules: {
			type: String,
			default: null,
		},
		/**
		 * Tên của control phục vụ việc hiện thị message cho validate
		 * Created by LTDAT(22.06.2020)
		 */
		name: {
			default: null,
			type: String,
		},
	},
	computed: {
		browserInfo() {
			const me = this;
			//Nếu không có thư viện commonFunc thì trả về unknown
			if (!me.$ms || !me.$ms.commonFunc) {
				return {
					navigationType: me.$ms.enum.NavigationType.Unknown,
				};
			}

			//Lấy thông tin từ trong thư viện commonFunc
			return me.$ms.commonFunc.getBrowserInfo();
		},
	},
	created() {
		const me = this;
		me.validateDebounce = _.debounce(me.validate, 500);
	},
	data() {
		return {
			errorProvider: {},
		};
	},
	methods: {
		getErrorProvider() {
			return this.errorProvider;
		},

		/**
		 * Validate component sự kiện validate control
		 * Created by LTDAT(22.06.2020)
		 *  */
		/**
		 * Truyền thêm tham số thứ 2 cho các trường hợp bắt buộc truyền 2 tham số ( ví dụ muốn kiểm tra link website có trong combobox hay không)
		 */
		validate(editor, data = null, isConnect = false, dataOptions) {
			const me = this;
			if (me.disabled || me.clearErroProvider) {
				me.errorProvider = {};
				return me.errorProvider;
			}
			let listRules = [],
				rulesValidate = null,
				ret = false;
			if (me.rules) {
				listRules = me.rules.split('|');
			}

			for (let i = 0; i < listRules.length; i++) {
				ret = !me.validateRule(
					listRules[i],
					me.internalText || me.value,
					editor,
					data,
					isConnect,
					dataOptions
				);
				if (ret) {
					rulesValidate = listRules[i];
					break;
				}
			}
			if (ret) {
				if (me.$t('i18nValidate.messages')[rulesValidate]) {
					me.$set(
						me.errorProvider,
						'message',
						me
							.$t('i18nValidate.messages')
							[rulesValidate](me.name ? me.name : me.title)
					);
				}
				me.$set(me.errorProvider, 'isValid', true);
				me.errorProvider.rules = rulesValidate;
				me.errorProvider.element = me.$refs.input;
			} else {
				me.errorProvider = {};
			}
			return me.errorProvider;
		},

		validateRule(
			rule,
			value,
			editor,
			data = null,
			isConnect = false,
			dataOptions
		) {
			const me = this;
			if (value && me.subtext) {
				value = value + me.subtext;
			}
			switch (rule) {
				case 'required':
					return me.validateRequired(value);
				case 'taxCodeOrIdentification':
					return validateTaxCodeOrIdentification(value);
				case 'taxCode':
					return validateTaxCode(value);
				case 'phoneEmail':
					return me.validatePhoneEmail(value);
				case 'phone':
					return me.validatePhone(value);
				case 'email':
					return me.validateEmail(value);
				case 'prefixemail':
					return me.validatePrefixEmail(value);
				case 'specialemail':
					return me.validateSpecialEmailCharacters(value);
				case 'sameasemail':
					return me.validateNotSameAsEmail(value, data);
				case 'password':
					return me.validatePassword(value);
				case 'requiredNumber':
					return me.validateNumberRequired(value);
				case 'requiredNumberMore0':
					return me.validateNumberRequiredMore0(value);
				case 'forceSelection':
					return me.validateForceSelection(value, editor);
				case 'positiveNumber':
					return me.validateNumber(value);
				case 'requiredIsNumber':
					return me.validateIsNumber(value);
				case 'tempSeries':
					return me.validDateTemplateNoSeries(value);
				case 'charactertext':
					return me.validateSpecialCharacters(value);
				case 'customRequired':
					return me.validateRequired(!me.internalText ? null : me.internalText);
				case 'invalidWebsite':
					return me.validateLinkWebsite(value, data, isConnect);
				case 'websiteInList':
					return me.validateWebsiteInList(value, data);
				case 'containData':
					return me.validateDataContain(value, data);
				case 'identificationNumber':
					return validateIdentificationNumber(value);
				case 'autocompleteCombobox':
					return me.validateAutoComboboxComplete(
						value,
						data,
						isConnect,
						dataOptions
					);
				case 'taxcodeWorking':
					return validateUsernameForTaxaxion(value, data, false);
				case 'identityNumberWorking':
					return validateUsernameForTaxaxion(value, data, true);
				case 'requiredNumberLess0':
					return me.validateNumberRequiredLess0(value);
				case 'templateNo':
					return me.validateTemplateNo(value);
				case 'seriesWithoutCode':
					return me.isValidateSeriesInvoiceWithoutCode(value);
				case 'requiredTrim':
					return me.validateRequired(value, true);
				case 'link':
					return me.validateLink(value, true);
				case 'rangeDateDuplicate':
					return me.validateRangeDuplicate(value, dataOptions);
				case 'excessiveLength': // Vượt quá đội dài cho phép
				case 'excessiveLength1':
					return me.validateExcessiveLength(value);
				case 'validateExistList':
					return me.validateExistList(value, dataOptions);
			}
		},
		/**
		 * Validate không cho phép nhập quá độ dài cho phép
		 * @param {*} value
		 */
		validateExcessiveLength(value) {
			if (value && value > window.__env.maxDayPaymentDueDateNumber) {
				return false;
			}
			return true;
		},
		validateIsNumber(value) {
			if (!value || value == '') return true;

			if (value && value.length > 0) {
				value = value.trim();
			}
			if (!value) return true;

			return /^-?[\d.]+(?:e-?\d+)?$/.test(value);
		},
		//Validate number required
		validateNumberRequired(value) {
			if (value === undefined || value === null || value === 0) {
				return false;
			} else {
				return true;
			}
		},
		//Validate number required
		validateNumberRequiredMore0(value) {
			if (value === undefined || value === null || value === 0) {
				return false;
			} else if (value > 0) {
				return true;
			}
		},
		// Validate number > 0
		validateNumber(value) {
			if (value <= 0) {
				return false;
			} else {
				return true;
			}
		},
		//Validate required
		validateRequired(value, isTrim = false) {
			if (isTrim && value) value = value.trim();
			if (value === undefined || value === null || value === '') {
				return false;
			} else {
				return true;
			}
		},
		validateTemplateNo(value) {
			try {
				if (value) {
					value = value.trim();
				}
				let lstTemplateNo = ['1', '2', '3', '4', '5', '6'];
				let checkValid = lstTemplateNo.find((x) => x == value);
				if (checkValid) return true;
				return false;
			} catch (e) {
				return false;
			}
		},
		validatePhoneEmail(value) {
			try {
				return this.validatePhone(value) || this.validateEmail(value);
			} catch (e) {
				return false;
			}
		},
		validatePhone(value) {
			if (value) {
				try {
					// let oRegex = /^(0|\+84)(\s|\.)?((3[2-9])|(5[689])|(7[06-9])|(8[1-689])|(9[0-46-9]))(\d)(\s|\.)?(\d{3})(\s|\.)?(\d{3})$/;
					let oRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
					let result = value;
					if (!oRegex.test(result.trim())) {
						return false;
					}
				} catch (e) {
					return false;
				}
			}
			return true;
		},
		validateEmail(value) {
			try {
				let oRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				let result = value;
				if (!oRegex.test(result.trim())) {
					return false;
				}
			} catch (e) {
				return false;
			}
			return true;
		},
		validatePrefixEmail(value) {
			try {
				let result = value;
				let numOccurrent = result.trim().split('@').length - 1;
				if (numOccurrent > 1) {
					return false;
				}
			} catch (e) {
				return false;
			}
			return true;
		},
		validateSpecialEmailCharacters(value) {
			try {
				let oRegex = /^[a-zA-Z\-0-9.\_\@]*$/;
				let result = value;
				if (!oRegex.test(result.trim())) {
					return false;
				}
			} catch (e) {
				return false;
			}
			return true;
		},
		// Validate email mới không được trùng email cũ (data là array chứa email cũ)
		validateNotSameAsEmail(value, data) {
			if (!value || !data || !Array.isArray(data) || data.length === 0) {
				return true;
			}

			return value.trim().toLowerCase() !== data[0].trim().toLowerCase();
		},
		validatePassword(value) {
			const me = this;
			let lengthPass = false;
			if (value && value.length >= 8) {
				lengthPass = true;
			}
			let textPass = false;
			let upcasePass = false;
			let lowercasePass = false;
			if (value && /[^A-Z]/g.test(value)) {
				upcasePass = true;
			}
			if (value && /[^a-z]/g.test(value)) {
				lowercasePass = true;
			}
			if (upcasePass && lowercasePass) {
				textPass = true;
			}
			let numberPass = false;
			if (value && /[^0-9]/g.test(value)) {
				numberPass = true;
			}
			me.$set(me.errorProvider, 'lengthPass', lengthPass);
			me.$set(me.errorProvider, 'textPass', textPass);
			me.$set(me.errorProvider, 'numberPass', numberPass);
			return lengthPass && textPass && numberPass;
		},
		validDateTemplateNoSeries(value) {
			const me = this;
			if (value && /[0-9A-Z-/]$/.test(value)) {
				return true;
			}
			return false;
		},
		validateForceSelection(value, editor) {
			const me = this;
			if (editor) {
				let dataSource = editor.internalDataSource;
				if (dataSource && dataSource.length > 0) {
					let typeAheadPointer = editor.filterIndexItemByText(value);
					if (
						typeAheadPointer != null &&
						typeAheadPointer != undefined &&
						typeAheadPointer >= 0
					) {
						return true;
					} else {
						return false;
					}
				}
			}
			return true;
		},
		applyValidate(message) {
			const me = this;
			if (message) {
				me.$set(me.errorProvider, 'message', message);
				me.$set(me.errorProvider, 'isValid', true);
				me.errorProvider.element = me.$refs.input;
			} else {
				me.errorProvider = {};
			}
		},
		validateDateRange(from, to) {
			if (from && to) {
				let startDate = new Date(from);
				let endDate = new Date(to);
				if (
					startDate.toLocaleDateString('en-ZA') >
					endDate.toLocaleDateString('en-ZA')
				) {
					return false;
				}
			}
			return true;
		},

		/**
		 * Hàm kiểm tra có chứa kí tự đặc biệt trong ô text hay không
		 */
		validateSpecialCharacters(value) {
			try {
				if (value === undefined || value === null || value === '') {
					return true;
				}
				let oRegex = />|<|cookie|onmouse|drop|exec|grant|union|delete|update|truncate|sysobjects|syslogins|sysremote|sysusers|sysxlogins|sysdatabases|execute|onclick/;
				let result = value;
				if (oRegex.test(result.trim())) {
					return false;
				}
			} catch (e) {
				return false;
			}
			return true;
		},
		//Validate website trong trường hợp để trong combo box và cần match với các trường hợp trong đó
		validateLinkWebsite(value, arr, isConnect = false) {
			let isValidate = isConnect
				? arr && arr.filter((item) => value && item.display == value).length > 0
				: arr &&
				  arr.filter((item) => value && item.display.contains(value)).length >
						0;
			return isValidate;
		},

		//Validate website chọn từ danh sách combobox — so sánh exact, bỏ qua khi value rỗng
		validateWebsiteInList(value, arr) {
			if (!value) return true;
			if (!arr || arr.length === 0) return true;
			return arr.filter((item) => item.display === value).length > 0;
		},

		validateLink(link) {
			try {
				new URL(link);
				return true;
			} catch (err) {
				return false;
			}
		},
		//Validate xem dữ liệu có tồn tại trong danh sách hay không
		validateDataContain(value, listData) {
			return value && listData && Array.from(listData).includes(value);
		},

		validateAutoComboboxComplete(value, arr, isConnect = false, dataOptions) {
			if (
				!dataOptions ||
				Object.keys(dataOptions).length <= 0 ||
				!dataOptions.displayField ||
				!dataOptions.valueField
			) {
				return true;
			}

			//ttanh (29/03/2024) sửa đoạn này vì đang k muốn cho tìm kiếm có chưa cũng thỏa mãn điều kiện con combobox
			let isValidate =
				arr &&
				arr.filter(
					(item) => value && item[`${dataOptions.displayField}`] == value
				).length > 0;
			return isValidate;
		},

		//Validate number required
		validateNumberRequiredLess0(value) {
			if (value === undefined || value === null || value === 0) {
				return false;
			} else if (value < 0) {
				return true;
			}
		},

		validateSeriesND123(value) {
			if (value) {
				value = value.trim();
			}
			//Rule của ký hiệu ND123
			//Ký tự đầu là C hoặc K. 2 ký tự tiếp là số cuối của năm dương lịch
			//1 Ký tự tiếp là trong các chữ cái sau :T, D, N, B, G, H
			//2 ký tự tiếp là chữ cái bất kỳ
			let seriesRegex = /[C|K]{1}[0-9]{2}[T|D|N|B|G|H]{1}[A-Z]{2}$/;
			if (value && seriesRegex.test(value)) {
				return true;
			}
			return false;
		},

		isInvoiceWithoutCode(value) {
			if (!value) return fasle;
			value = value.trim();
			return value.startsWith('K');
		},

		isValidateSeriesInvoiceWithoutCode(value) {
			const me = this;
			value = value.trim();
			return me.isInvoiceWithoutCode(value) && me.validateSeriesND123(value);
		},

		validateRangeDuplicate(value, dataOptions) {
			return dataOptions && dataOptions.isDuplicate;
		},

		validateExistList(value, dataOptions) {
			if (
				!value ||
				!dataOptions ||
				!dataOptions.lstData ||
				dataOptions.lstData <= 0
			) {
				return true;
			}

			if (dataOptions && dataOptions.newValue == 'KHAC') return true;
			return dataOptions.lstData.includes(value);
		},

		validateTaxCodeOrIdentificationBase(value) {
			return validateTaxCodeOrIdentification(value);
		},

		/**
		 * @param value
		 * @param orgInfo: cấu trúc dữ liệu của orgInfo
			*{
				"IsBusinessHousehold": false,
				"LstData": [ // Danh sách MST, CCCdan của CCTC làm việc
					"0101243150"
				]
			}
		 */
		validUserNameTaxaxion(value, orgInfo) {
			const me = this;
			if (!validateTaxCodeOrIdentification(value)) return false;
			return listData && value && Array.from(listData).includes(value);
		},
	},
};
</script>
<style lang="scss" scoped></style>
